<template>
  <div class="app-customizer">
    <v-btn
      icon
      class="app-customizer-toggler rounded-0"
      :class="$vuetify.rtl ? 'rounded-r-lg' : 'rounded-l-lg'"
      color="white"
      large
      @click="isCustomizerOpen = !isCustomizerOpen"
    >
      <v-icon size="25">
        {{ icons.mdiCog }}
      </v-icon>
    </v-btn>
    <v-navigation-drawer
      v-model="isCustomizerOpen"
      :right="!$vuetify.rtl"
      temporary
      fixed
      width="400"
      class="app-customizer-drawer"
    >
      <!-- Heading -->
      <div class="app-customizer-header customizer-section py-3">
        <h6
          class="font-weight-semibold text-xl text--primary"
        >
         {{$t('theme.title')}}
        </h6>
        <span class="text--secondary">{{$t('theme.subTitle')}}</span>
        <v-btn
          icon
          class="icon-customizer-close"
          @click="isCustomizerOpen = false"
        >
          <v-icon>
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>

      <perfect-scrollbar
        :options="perfectScrollbarOptions"
        class="ps-customizer"
      >
        <!-- Section: Themeing -->
        <div class="customizer-section">
          <p class="text-xs text--disabled">
            {{$t('theme.themeSet.title')}}
          </p>
          <!-- Skin -->
          <span class="text--primary">{{$t('theme.themeSet.skin.title')}}</span>
          <v-radio-group
            v-model="appSkinVariant"
            class="mt-1"
            hide-details
            row
            @change="themeingFun($event, 'skinVariant')"
          >
            <v-radio
              v-for="option in skinOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
          <!-- Mode -->
          <span class="mt-6 d-inline-block mb-2 text--primary">{{$t('theme.themeSet.mode.title')}}</span>
          <div class="d-flex align-center">
            <span class="text--secondary text-sm">{{$t('theme.themeSet.mode.highlight')}}</span>
            <v-switch
              v-model="isDark"
              hide-details
              class="mt-0 mx-2"
              @change="themeingFun($event, 'dark')"
            ></v-switch>
            <span class="text--secondary text-sm">{{$t('theme.themeSet.mode.dark')}}</span>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Section: Themeing -->
        <div class="customizer-section">
          <p class="text-xs text--disabled">
            {{$t('theme.layoutSet.title')}}
          </p>

          <!-- Content Width -->
          <span class="text--primary">{{$t('theme.layoutSet.bodyWidth.title')}}</span>
          <v-radio-group
            v-model="appContentWidth"
            class="mt-1"
            hide-details
            @change="themeingFun($event, 'contentWidth')"
            row
          >
            <v-radio
              v-for="option in appContentWidthOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></v-radio>
          </v-radio-group>

          <!-- AppBar Type -->
          <span class="mt-6 d-inline-block text--primary">{{$t('theme.layoutSet.appType.title')}}</span>
          <v-radio-group
            v-model="appBarType"
            class="mt-1"
            hide-details
            row
            @change="themeingFun($event, 'type')"
          >
            <v-radio
              v-for="option in appBarTypeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></v-radio>
          </v-radio-group>

          <!-- Footer Type -->
          <!-- <span class="mt-6 d-inline-block text--primary">底部类型</span>
          <v-radio-group
            v-model="footerType"
            class="mt-1"
            hide-details
            row
          >
            <v-radio
              v-for="option in footerTypeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></v-radio>
          </v-radio-group> -->

          <!-- Blur -->
          <!-- <div class="d-flex align-center justify-space-between mt-6">
            <span class="text--primary">AppBar Blur</span>
            <v-switch
              v-model="appBarIsBlurred"
              hide-details
              class="mt-0 ms-2"
            ></v-switch>
          </div> -->
        </div>

        <v-divider></v-divider>

        <!-- Section: Menu -->
        <div class="customizer-section">
          <p class="text-xs text--disabled">
            {{$t('theme.layoutSet.nav.title')}}
          </p>

          <!-- Menu Collapsed -->
          <div
            v-if="appContentLayoutNav === 'vertical'"
            class="d-flex align-center justify-space-between mt-6"
          >
            <span class="text--primary"> {{$t('theme.layoutSet.nav.merge')}}</span>
            <v-switch
              v-model="menuIsVerticalNavMini"
              hide-details
              class="mt-0 ms-2"
              @change="themeingFun($event, 'isVerticalNavMini')"
            ></v-switch>
          </div>

          <!-- Menu Hidden -->
          <div class="d-flex align-center justify-space-between mt-6">
            <span class="text--primary">{{$t('theme.layoutSet.nav.hide')}}</span>
            <v-switch
              v-model="menuIsMenuHidden"
              hide-details
              class="mt-0 ms-2"
              @change="themeingFun($event, 'isMenuHidden')"
            ></v-switch>
          </div>
        </div>
        <v-divider></v-divider>
      </perfect-scrollbar>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { computed, ref, watch, getCurrentInstance } from '@vue/composition-api'
import useAppConfig from '@core/@app-config/useAppConfig'

import { mdiCog, mdiClose } from '@mdi/js'

import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import themeVariants from './themeVariants'
import { getTheme, updateTheme } from "@/api/index";
import { getVuetify } from '@core/utils'
import store from '@/store'
import $vue from '@/main.js'
import {IsPC} from '@/utils'

import { getCookie, setCookie } from '@/utils/cookie';
// 3rd Party

export default {
  components: {
    PerfectScrollbar,
  },
  setup() {



    const isCustomizerOpen = ref(false)
    // eslint-disable-next-line object-curly-newline
    // const {
    //   appContentLayoutNav,
    //   appSkinVariant,
    //   appContentWidth,
    //   appRouteTransition,
    //   menuIsVerticalNavMini,
    //   menuIsMenuHidden,
    //   appBarType,
    //   appBarIsBlurred,
    //   footerType,
    //   isDark,
    //   isRtl,
    //   themes,
    // } = useAppConfig()

    const selectedTheme = ref('vuexy')

    const routerTransitionOptions = [
      { text: 'Scroll X', value: 'scroll-x-transition' },
      { text: 'Scroll X Reverse', value: 'scroll-x-reverse-transition' },
      { text: 'Scroll Y', value: 'scroll-y-transition' },
      { text: 'Scroll Y Reverse', value: 'scroll-y-reverse-transition' },
      { text: 'Slide X', value: 'slide-x-transition' },
      { text: 'Slide X Reverse', value: 'slide-x-reverse-transition' },
      { text: 'Slide Y', value: 'slide-y-transition' },
      { text: 'Slide Y Reverse', value: 'slide-y-reverse-transition' },
      { text: 'Fade', value: 'fade-transition' },
    ]

    const skinOptions = computed(() => {

      const options = [
        { label: $vue.$t('theme.themeSet.skin.default'), value: 'default' },
        { label: $vue.$t('theme.themeSet.skin.border'), value: 'bordered' },
        { label: $vue.$t('theme.themeSet.skin.dark'), value: 'semi-dark' },
      ]
      if (appContentLayoutNav.value === 'horizontal') options.splice(-1, 1)

      return options
    })

    const appContentWidthOptions = [
      { label:$vue.$t('theme.layoutSet.bodyWidth.beFilledWith'), value: 'full' },
      { label:$vue.$t('theme.layoutSet.bodyWidth.fine'), value: 'boxed' },
    ]

    const appBarTypeOptions = computed(() => {
      const types = [
        { label: $vue.$t('theme.layoutSet.appType.fixed'), value: 'fixed' },
        { label: $vue.$t('theme.layoutSet.appType.show'), value: 'static' },
        { label: $vue.$t('theme.layoutSet.appType.hide'), value: 'hidden' },
      ]
      if (appContentLayoutNav.value === 'horizontal') types.splice(-1, 1)

      return types
    })

    // const footerTypeOptions = [
    //   { label: '固定', value: 'fixed' },
    //   { label: '显示', value: 'static' },
    //   { label: '隐藏', value: 'hidden' },
    // ]

    const appContentLayoutNavOptions = [
      { label: 'Vertical', value: 'vertical' },
      { label: 'Horizontal', value: 'horizontal' },
    ]

    const perfectScrollbarOptions = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const $vuetify = getVuetify()

    // 设置默认值
    const appContentLayoutNav = ref(store.state.appConfig.app.contentLayoutNav)
    const isRtl = $vuetify.rtl

    const isDark = ref(false)
    const appSkinVariant = ref("default")
    const appContentWidth = ref("full")
    const appBarType = ref("fixed")
    const menuIsVerticalNavMini = ref(false)
    const menuIsMenuHidden = ref(false)

    store.commit('appConfig/UPDATE_THEMES', $vuetify.theme.themes)
    $vuetify.theme.themes.light = $vuetify.theme.themes.light
    $vuetify.theme.themes.dark = $vuetify.theme.themes.dark

    // 获取主题风格
    const getThemeFun = () => {
      getTheme().then(res=> {
        if(res.code == 200) {
          if(res.data != null) {
            let datas = res.data
            if(datas.materioActiveTheme != undefined) {
              appSkinVariant.value =  datas.materioActiveTheme == 0 ? 'default' : datas.materioActiveTheme == 1 ? 'bordered' : 'semi-dark'
              setThemeFun('skinVariant')
            }
            if(datas.materioSkinVariant != undefined) {
              isDark.value = datas.materioSkinVariant == 1 ? true : false
              setThemeFun('dark')
            }
            if(datas.appContentWidth != undefined) {
              appContentWidth.value = (datas.appContentWidth == 0 || !IsPC())? 'full' : 'boxed'
              setThemeFun('contentWidth')
            }
            if(datas.appBarType != undefined) {
              appBarType.value = (datas.appBarType == 0 || !IsPC()) ? 'fixed' : datas.appBarType == 1 ? 'static' : 'hidden'
              setThemeFun('type')
            }
            if(datas.menuIsVerticalNavMini != undefined) {
              menuIsVerticalNavMini.value = (datas.menuIsVerticalNavMini == 1  && IsPC())  ? true : false
              setThemeFun('isVerticalNavMini')
            }
            if(datas.menuIsMenuHidden != undefined) {
              menuIsMenuHidden.value = (datas.menuIsMenuHidden == 1  && IsPC()) ? true : false
              setThemeFun('isMenuHidden')
            }
          }else{
            setThemeFun('dark')
            console.log($vuetify.theme.dark)
          }
        }
      })
    }
    getThemeFun()

    // 更改风格
    const updateThemeFun = (params, key) => {
      updateTheme(params).then(res=> {
        if(res.code == 200) {
          setThemeFun(key)
        }
      })
    }

    const setThemeFun = (key) => {
      switch (key) {
        case 'skinVariant':
          store.commit('appConfig/UPDATE_APP_SKIN_VARIANT', appSkinVariant.value)
          localStorage.setItem('materio-skin-variant', appSkinVariant.value)
          break;
        case 'dark':
          $vuetify.theme.dark = isDark.value
          localStorage.setItem('materio-active-theme', isDark.value == 0 && isDark.value !=false ? 'dark' : 'light')
          setCookie('materio-active-theme',isDark.value == 0 ? 'dark' : 'light')
          break;
        case 'contentWidth':
          store.commit('appConfig/UPDATE_APP_CONTENT_WIDTH', appContentWidth.value)
          break;
        case 'type':
          store.commit('appConfig/UPDATE_APP_BAR_TYPE', appBarType.value)
          break;
        case 'isVerticalNavMini':
          store.commit('appConfig/TOGGLE_MENU_VERTICAL_NAV_MINI', menuIsVerticalNavMini.value)
          break;
        case 'isMenuHidden':
          store.commit('appConfig/TOGGLE_MENU_MENU_HIDDEN', menuIsMenuHidden.value)
          break;
      }
    }

    const themeingFun = (val, key) => {
      switch (key) {
        case 'skinVariant':
          updateThemeFun({materioActiveTheme: val == 'default' ? 0 : val == 'bordered' ? 1 : 2}, 'skinVariant')
          break;
        case 'dark':
          updateThemeFun({materioSkinVariant: val ? 1 : 0}, 'dark')
          break;
        case 'contentWidth':
          updateThemeFun({appContentWidth: val == "full" ? 0 : 1}, 'contentWidth')
          break;
        case 'type':
          updateThemeFun({appBarType: val == "fixed" ? 0 : val == "static" ? 1 : 2}, 'type')
          break;
        case 'isVerticalNavMini':
          updateThemeFun({menuIsVerticalNavMini: val ? 1 : 0}, 'isVerticalNavMini')
          break;
        case 'isMenuHidden':
          updateThemeFun({menuIsMenuHidden: val ? 1 : 0}, 'isMenuHidden')
          break;
      }
    }


    getCurrentInstance().proxy.$root.eventHub.$on('changeDark', ()=> {
      isDark.value = $vuetify.theme.dark
    })

    return {
      isCustomizerOpen,
      selectedTheme,
      // appRouteTransition,
      themeVariants,

      // App Content Layout Nav
      appContentLayoutNavOptions,
      appContentLayoutNav,

      // Skin
      appSkinVariant,
      skinOptions,

      // App Content Width
      appContentWidth,
      appContentWidthOptions,

      menuIsMenuHidden,
      menuIsVerticalNavMini,

      // AppBar Type
      appBarType,
      // appBarIsBlurred,
      appBarTypeOptions,

      // Footer Type
      // footerType,
      // footerTypeOptions,

      isDark,
      isRtl,
      // themes,
      routerTransitionOptions,

      // Perfect scrollbar options
      perfectScrollbarOptions,

      // Icons
      icons: {
        mdiCog,
        mdiClose,
      },
      themeingFun,
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.ps-customizer {
  height: calc(100% - 81px) !important;
}

.app-customizer-toggler {
  position: fixed;
  top: 50%;
  transform: translateX(-50%);
  background: var(--v-primary-base);
  @include ltr() {
    right: -22px;
  }
  @include rtl() {
    left: 20px;
  }
}

@include theme(app-customizer-drawer) using ($material) {
  background-color: map-deep-get($material, 'cards');
}

.app-customizer {
  z-index: 7;

  .v-label {
    font-size: 0.875rem;
  }

  .app-customizer-header {
    position: relative;
    .icon-customizer-close {
      position: absolute;
      @include ltr() {
        right: 20px;
      }
      @include rtl() {
        left: 20px;
      }
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .customizer-section {
    padding: 24px;
  }

  // Fixes Overlay is shown below SystemBar
  @at-root {
    .v-overlay {
      & + .v-application--wrap > .v-system-bar {
        z-index: 6 !important;
      }
    }
  }
}
</style>
